import React from 'react';

import './Footer.css';

function Footer() {
    return (
        <section id="footer">
            <div className="footer-container">
                <p>&copy; 2024 Charles Zhu</p>
            </div>
        </section>
    )
}

export default Footer;